export default "__VITE_ASSET__BoS68Gte__"